<!-- 確認画面用セクション: タイトル + テーブルのラッパーコンポーネント -->
<template>
  <div class="confirm-section">
    <h3 class="confirm-title">{{ title }}</h3>
    <table class="confirm-table">
      <tbody>
        <slot />
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
}>();
</script>
